/**
 * Shared safe-number limits aligned with Joi's default number.unsafe check
 * (values must stay within Number.MAX_SAFE_INTEGER).
 */
export const NUMERIC_SAFE_MAX = Number.MAX_SAFE_INTEGER
export const NUMERIC_SAFE_MIN = Number.MIN_SAFE_INTEGER

export const isSafeNumericValue = value => {
  if (value === null || value === undefined) return true
  if (typeof value !== "number") return false
  if (Number.isNaN(value)) return true // let Yup typeError handle NaN
  return Number.isFinite(value) && Math.abs(value) <= NUMERIC_SAFE_MAX
}
